module.exports = __webpack_public_path__ + "img/left.01d6ef5f.svg";